import React from 'react';
import PropTypes from 'prop-types';
import {getResizeImagePaths, onImageError} from '../../../../utils';
import {Modal} from '../../../common';

const QuestionImageModal = (props) => {
  const {url, title, isModalOpened, onModalClose} = props;

  const {defaultImageURL, resizedImageURL} = getResizeImagePaths(url, 542);

  return (
    <Modal
      isOpen={isModalOpened}
      onClose={onModalClose}
      textAlign="center"
      contentStyles="modal__content_padding_s"
    >
      <img
        src={resizedImageURL}
        onError={onImageError(defaultImageURL)}
        alt={title}
      />
    </Modal>
  );
};

QuestionImageModal.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  onModalClose: PropTypes.func.isRequired,
  isModalOpened: PropTypes.bool.isRequired,
};

QuestionImageModal.defaultProps = {
  title: '',
};

export default QuestionImageModal;
